<template>
  <div v-loading.fullscreen.lock="loadingContent" element-loading-text="Saindo do sistema..."></div>
</template>

<script>
import Rest from "common/rest";


export default {
  name: "logout",
  components: {},
  mixins: [Rest],
  data() {
    return {
      loadingContent:false
    };
  },

  mounted() {
    this.inicialize();
  },

  methods: {

    inicialize(){

      if(!this.logged()){
        this.toRoute({name:this.sub_domain+'.login'});
        return
      }

      var self = this;

      this.$confirm('Tem certeza que deseja encerrar sua sessão no sistema?', 'Atenção', {
          type: 'warning'

      }).then(() => {

        self.loadingContent = true;

        this.post("usuario/logout").then(result => {
          result = result[0];
          self.loadingContent = false;
          this.logout();
        });

      }).catch(()=>{
        this.toRoute({name:this.sub_domain+'.home'});
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// logout.vue?1ca249a2